
<template>

    <div v-if="IsVisible" class="bonchef-alert-wrapper" :style="{right:GetBonChefXPos() + '%'}">

        <div :class="['bonchef-alert', {'prior-bonchef': this.repo.bonchefInstructionsWaiting === 0}]">

            <span v-if="this.repo.bonchefInstructionsWaiting > 1" class="bonchef-count">
                {{this.repo.bonchefInstructionsWaiting}}
            </span>

            <div class="batch-items">
                <div v-for="product in Products" :key="product.id">
                    <div class="batch-item">
                        <span class="batch-item-amount">{{product.weightedQuantity > product.quantity ? product.weightedQuantity : product.quantity}}</span>
                        <span class="batch-item-description">{{product.name}}</span>
                    </div>
                </div>
            </div>

            <div v-if="this.repo.bonchefInstructionsWaiting > 0" class="bonchef-button" v-on:click="doBonChef">
                <span>{{FirstBonChef.createdAtUtc | formatTime}}</span>
                <span class="button-divider"></span>
                <span><translate item="BonChef.DoBonChef" /></span>
            </div>
            <div v-else class="bonchef-button-close" v-on:click="hidePriorBonChef">
                <span>{{FirstBonChef.createdAtUtc | formatTime}}</span>
                <span class="button-divider"></span>
                <span><translate item="BonChef.Close" /></span>
            </div>

        </div>

        <div v-if="this.repo.bonchefInstructionsWaiting > 1" class="bonchef-alert-multiple"></div>

    </div>

</template>

<script>

    import translate from '../components/translate'
    import timeStore from '../repositories/TimeManager';
    import bonchefRepository from '../repositories/BonchefRepository';

    const BonChef = {

        components: { translate },

        data: function () {
            return {
                Que: bonchefRepository.que,
                repo: bonchefRepository
            }
        },

        props: {
            MarkerDate: { type: Date },
        },

        methods: {

            doBonChef: function () {
                bonchefRepository.doBonChef();
            },

            hidePriorBonChef: function () {
                bonchefRepository.hidePriorBonChef();
            },

            GetBonChefXPos: function () {
                return this.FirstBonChef ? timeStore.calculateXPosition(this.FirstBonChef.createdAtUtc).toFixed(0) : 0;
            },

        },

        computed: {

            FirstBonChef: function () {
                return this.Que.find(q => q.confirmedAtUtc === null || q.showPriorBonchef);
            },

            Batches: function () {
                return this.Que.length && this.FirstBonChef ? this.FirstBonChef.batches  : [];
            },

            Products: function () {
              
                
                let bonchef_products = [];

                if (this.Batches) {
                    this.Batches.forEach(function (batch) {
                        batch.products.forEach(function (product) {

                            // product already in bonchef instruction?
                            let duplicate = bonchef_products.find(a => a.productId == product.productId);

                            if (duplicate) {
                                duplicate.quantity += product.quantity;
                                duplicate.weightedQuantity += product.weightedQuantity;
                            } else {

                                // search original product name
                                let _name = '';
                                let orderProduct = null;

                                // Get original product name from Order.Products
                                outerLoop: for (const order of product.orders) {
                                    for (const prd of order.products) {
                                        // check for single product here
                                        if (prd.id === product.id) {
                                            orderProduct = prd;
                                            break outerLoop;
                                        }
                                        // single product not found,
                                        // search for product within menu (dishgroup)
                                        else if (prd.isDishGroupholder && prd.children) {
                                            const child = prd.children.find(child => child.id === product.id);
                                            if (child) {
                                                orderProduct = child;
                                                break outerLoop;
                                            }
                                        }
                                    }
                                }

                                if (orderProduct) {
                                    _name = orderProduct.name;
                                    if (orderProduct.children && orderProduct.children.length) {
                                        orderProduct.children.forEach(a => _name += ' + ' +  a.name);
                                    }
                                }
                                
                                // product not found?
                                if (_name.length === 0) {
                                    // set batch-product-name with error 
                                    _name = "[name_err] " + product.name;
                                }
                                else if (product.weightedQuantity > product.quantity) {
                                    _name = `porties van ${_name}`;
                                }

                                bonchef_products.push({ 'name': _name, 'productId': product.productId, 'quantity': product.quantity, 'weightedQuantity': product.weightedQuantity });
                            }

                        });
                    });
                }
                
                return bonchef_products;
            },

            IsVisible: function () {
                return this.repo.bonchefInstructionsWaiting > 0 || this.Que.find(q => q.showPriorBonchef);
            }

        }

    };

    export { BonChef as default };

</script>
